import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem("loginData")
  ? JSON.parse(localStorage.getItem("loginData")!)
  : {
      authChecked: false,
      loggedIn: false,
      token: "",
    };

export const authorizationSlice = createSlice({
  name: "authorization",
  initialState,

  reducers: {
    login: (state, action) => {
      const payload = {
        authChecked: true,
        loggedIn: true,
        token: action.payload.accessToken,
        user: action.payload.User,
      };
      localStorage.setItem("loginData", JSON.stringify(payload));

      return payload;
    },
    logout: (state, action) => {
      localStorage.removeItem("loginData");
      localStorage.removeItem("likes");

      return action.payload;
    },
  },
});

export const { login, logout } = authorizationSlice.actions;

// export const selectItems = (state:any) => state;

export default authorizationSlice.reducer;
